import axios from "axios";

const AdminBaseUrl = process.env.REACT_APP_AdminBaseUrl;
export const arabicTextExtraction = async (data) => {
    try {
        const response = await axios.post(`${AdminBaseUrl}/arabic_text_extraction/`, data, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });
        return {
            status: true,
            data: response.data
        }

    } catch (error) {
        return {
            status: false,
            data: null,
            error: error?.
                message
        }
    }
};